// extracted by mini-css-extract-plugin
export default {"nav-tab":"VerticalTab_nav-tab__VnfgV","nav-item":"VerticalTab_nav-item__TipaF","nav-link":"VerticalTab_nav-link__4YKEz","nav-link-content":"VerticalTab_nav-link-content__S5QRT"};